var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5500_4485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5500_4485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30775 18.5157V17.0275H20.5V18.5157H9.30775ZM9.30775 12.5629V11.0748H20.5V12.5629H9.30775ZM9.30775 6.61019V5.122H20.5V6.61019H9.30775ZM5.1635 19.422C4.706 19.422 4.31442 19.2604 3.98875 18.9371C3.66292 18.614 3.5 18.2255 3.5 17.7716C3.5 17.3177 3.66292 16.9292 3.98875 16.6061C4.31442 16.2828 4.706 16.1212 5.1635 16.1212C5.621 16.1212 6.01258 16.2828 6.33825 16.6061C6.66408 16.9292 6.827 17.3177 6.827 17.7716C6.827 18.2255 6.66408 18.614 6.33825 18.9371C6.01258 19.2604 5.621 19.422 5.1635 19.422ZM5.1635 13.4693C4.706 13.4693 4.31442 13.3076 3.98875 12.9844C3.66292 12.6613 3.5 12.2728 3.5 11.8189C3.5 11.365 3.66292 10.9765 3.98875 10.6534C4.31442 10.3301 4.706 10.1685 5.1635 10.1685C5.621 10.1685 6.01258 10.3301 6.33825 10.6534C6.66408 10.9765 6.827 11.365 6.827 11.8189C6.827 12.2728 6.66408 12.6613 6.33825 12.9844C6.01258 13.3076 5.621 13.4693 5.1635 13.4693ZM5.1635 7.5165C4.706 7.5165 4.31442 7.35487 3.98875 7.0316C3.66292 6.7085 3.5 6.32 3.5 5.8661C3.5 5.4122 3.66292 5.0237 3.98875 4.7006C4.31442 4.37733 4.706 4.2157 5.1635 4.2157C5.621 4.2157 6.01258 4.37733 6.33825 4.7006C6.66408 5.0237 6.827 5.4122 6.827 5.8661C6.827 6.32 6.66408 6.7085 6.33825 7.0316C6.01258 7.35487 5.621 7.5165 5.1635 7.5165Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/ListView.e215c4aef90fdc6f5234c8f7b9f21a96.svg";
export { ForwardRef as ReactComponent };